import { render, staticRenderFns } from "./shopBannerAttr.vue?vue&type=template&id=8711ee64&scoped=true"
import script from "./shopBannerAttr.vue?vue&type=script&lang=js"
export * from "./shopBannerAttr.vue?vue&type=script&lang=js"
import style0 from "./shopBannerAttr.vue?vue&type=style&index=0&id=8711ee64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8711ee64",
  null
  
)

component.options.__file = "shopBannerAttr.vue"
export default component.exports